import { Component, OnInit } from "@angular/core";
import {
  connect,
  Room,
  createLocalTracks,
  RemoteParticipant,
  Video
} from "twilio-video";
import { VideoLibraryService } from "./../service/video-library.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-video-library",
  templateUrl: "./video-library.component.html",
  styleUrls: ["./video-library.component.css"]
})
export class VideoLibraryComponent implements OnInit {
  activeRoom: any;
  previewTracks: any;
  identity: any;
  roomName: any;
  appId: number;
  roomId: string;
  track: any;
  enterRoom: string;
  token: string;
  orderId: string;
  timerData = "";
  isLoaded = false;
  PatientName = "";
  DoctorName = "";
  appointmentCompleted = false;

  constructor(
    private _videoLibraryService: VideoLibraryService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params.hasOwnProperty("id")) {
        this.orderId = params["id"];
        this._videoLibraryService
          .getVideoToken(this.orderId)
          .subscribe(data => {
            if (data != null) {
              //let d = new Date();
              // let appD = new Date(data.AppointmentDayTime);
              // var diff =(appD.getTime() - d.getTime()) / 1000;
              // diff /= 60;
              // let difference= Math.round(diff);
              this.DoctorName = data.DoctorName;
              this.PatientName = data.PatientName;
              if (data.IsAvailable == "1") {
                this.showTimer(data.TotalTime);
                this.token = data.VideoToken;
                this.roomId = data.RoomId;
                this.appId = data.AppointmentId;
                this.roomName = data.RoomName;
                this.enterRoom = this.roomName;
                this.connectToRoom();
              } else {
                alert(
                  "You can join the appointment only 2min. before the appointment time. You get a max. time of 13mins. to join after the appt. starts."
                );
                this.router.navigate(["main/dashboard"]);
              }
            }
          });
      }
    });
  }

  sendNotification() {
    this._videoLibraryService
      .sendNotificationToPatient(this.orderId, this.appId, this.roomId)
      .subscribe(
        data => {
          alert("Notification sent successfully");
        },
        error => {}
      );
  }

  // Attach the Tracks to the DOM.
  attachTracks(tracks, container) {
    tracks.forEach(publication => {
      if (publication.track) {
        container.appendChild(publication.track.attach());
        setTimeout(() => {
          this.isLoaded = true;
        }, 7000);
      }
    });
  }

  // Attach the Participant's Tracks to the DOM.
  attachParticipantTracks(participant, container) {
    const tracks = participant.tracks;
    this.attachTracks(tracks, container);
    $("#local-media video")
      .attr("width", "200")
      .attr("height", "150");
  }

  // Detach the Tracks from the DOM.
  detachTracks(tracks) {
    tracks.forEach(track => {
      if (track.track) {
        track.track.detach().forEach(detachedElement => {
          detachedElement.remove();
        });
      }
    });
  }

  // Detach the Participant's Tracks from the DOM.
  detachParticipantTracks(participant) {
    const tracks = participant.tracks;
    this.detachTracks(tracks);
  }

  disconnectFromRoom() {
    this.activeRoom?.disconnect();
   
  }

  showTimer(t) {
    //let d1 = new Date(appTime);
    // let  d2 = new Date(d1);
    //  d2.setMinutes(d1.getMinutes() + 15);
    // let date = d2;
    let countDownDate = t; //new Date(date).getTime();
    const x = setInterval(() => {
      // var now = new Date().getTime();
      countDownDate = countDownDate - 1000;
      const minutes = Math.floor(
        (countDownDate % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((countDownDate % (1000 * 60)) / 1000);
      this.timerData = "Time Remaining: " + minutes + "m " + seconds + "s ";
      if (countDownDate <= 0) {
        clearInterval(x);
        $("#button-leave").click();
      }
    }, 1000);
  }

  connectToRoom() {
    //this.roomName = this.enterRoom;
    if (!this.roomName) {
      alert("Please enter a room name.");
      return;
    }

    this.log("Joining room " + this.roomName + "...");
    const connectOptions = {
      name: this.roomName,
      logLevel: "debug",
      tracks: this.track,
      isLoaded: false,
      VideoCodecs: ["VP8", "H264"]
    };

    if (this.previewTracks) {
      connectOptions.tracks = this.previewTracks;
    }

    // Join the Room with the token from the server and the
    // LocalParticipant's Tracks.
    connect(
      this.token,
      connectOptions
    ).then(
      room => {
        this.roomJoined(room);
      },
      error => {
        const logDiv = document.getElementById("log");
        logDiv.innerHTML +=
          "<p>&gt;&nbsp;" +
          "Could not connect to Twilio: " +
          error.message +
          "</p>";
        logDiv.scrollTop = logDiv.scrollHeight;
      }
    );
  }

  updateDoctorJoiningStatus() {}
  handleTrackDisabled(track) {
    track.on("disabled", () => {
      /* Hide the associated <video> element and show an avatar image. */
    });
  }
  // Successfully connected!
  roomJoined(room) {
    this.activeRoom = room;

    this.log("Joined as " + this.identity);
    //document.getElementById("button-join").style.display = "none";
    // Attach LocalParticipant's Tracks, if not already attached.
    const previewContainer = document.getElementById("local-media");
    if (!previewContainer.querySelector("video")) {
      this._videoLibraryService
        .updateDoctorJoiningStatus(this.orderId)
        .subscribe(data => {}, error => {});
      this.attachParticipantTracks(room.localParticipant, previewContainer);
    }

    // Attach the Tracks of the Room's Participants.
    room.participants.forEach(participant => {
      this.log("Already in Room: " + participant.identity);

      // document.getElementById('button-leave').style.display = 'inline';

      const previewContainer = document.getElementById("remote-media");
      this.attachParticipantTracks(participant, previewContainer);
    });
    room.participants.forEach(participant => {
      participant.tracks.forEach(publication => {
        if (publication.track) {
          this._videoLibraryService.updateDoctorJoiningStatus(this.orderId);
          document
            .getElementById("remote-media")
            .appendChild(publication.track.attach());
        }
      });

      participant.on("trackSubscribed", track => {
        document.getElementById("remote-media").appendChild(track.attach());
      });
    });
    // When a Participant joins the Room, log the event.
    room.on("participantConnected", (track, participant) => {
      // document.getElementById('button-leave').style.display = 'inline';

      //this.log("Joining: " + participant.identity);
      const previewContainer = document.getElementById("remote-media");
      this.attachTracks([track], previewContainer);
    });

    // When a Participant adds a Track, attach it to the DOM.
    room.on("trackAdded", (track, participant) => {
      this.log(participant.identity + " added track: " + track.kind);
      const previewContainer = document.getElementById("remote-media");
      this.attachTracks([track], previewContainer);
    });

    // When a Participant removes a Track, detach it from the DOM.
    room.on("trackRemoved", (track, participant) => {
      this.log(participant.identity + " removed track: " + track.kind);
      this.detachTracks([track]);
    });

    // When a Participant leaves the Room, detach its Tracks.
    room.on("participantDisconnected", participant => {
      this.log("Participant " + participant.identity + " left the room");
      this.detachParticipantTracks(participant);
    });

    // Once the LocalParticipant leaves the room, detach the Tracks
    // of all Participants, including that of the LocalParticipant.
    room.on("disconnected", () => {
      this.log("Left");
      if (this.previewTracks) {
        this.previewTracks.forEach(function(track) {
          track.stop();
        });
        this.previewTracks = null;
      }
      this.detachParticipantTracks(room.localParticipant);
 
      room.participants.forEach(item => {
        this.detachParticipantTracks(item);
      });
      if(room.localParticipant) {
        this.activeRoom = null;
        this.appointmentCompleted = true;
        this._videoLibraryService
          .updateDoctorDisconnectStatus(this.orderId)
          .subscribe(
            data => {
              setTimeout(() => {
                this.router.navigate(["main/dashboard"]);
              }, 2000);
            },
            error => {}
          );}
      //document.getElementById("button-join").style.display = "inline";
      document.getElementById("button-leave").style.display = "none";
    });
  }
  handleTrackEnabled(track) {
    track.on("enabled", () => {
      /* Hide the avatar image and show the associated <video> element. */
    });
  }
  previewButtonHandler() {
    const localTracksPromise = this.previewTracks
      ? Promise.resolve(this.previewTracks)
      : createLocalTracks();

    localTracksPromise.then(
      tracks => {
        this.previewTracks = tracks;
        const previewContainer = document.getElementById("local-media");
        if (!previewContainer.querySelector("video")) {
          this.attachTracks(tracks, previewContainer);
        }
      },
      function(error) {
        console.error("Unable to access local media", error);
        const logDiv = document.getElementById("log");
        logDiv.innerHTML +=
          "<p>&gt;&nbsp;Unable to access Camera and Microphone</p>";
        logDiv.scrollTop = logDiv.scrollHeight;
      }
    );
  }

  // Activity log.
  log(message) {
    /*const logDiv = document.getElementById("log");
    logDiv.innerHTML += "<p>&gt;&nbsp;" + message + "</p>";
    logDiv.scrollTop = logDiv.scrollHeight;*/
  }

  // Leave Room.
  leaveRoomIfJoined() {
    if (this.activeRoom) {
      this.activeRoom.disconnect();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/section/video/video-library/video-library.component.ts